import React, { useEffect, useState } from 'react';
import './BattleDefeat.css';

interface BattleDefeatProps {
  battleName?: string;
  turnsSurvived: number;
  enemiesDefeated: number;
  onContinue: () => void;
}

const BattleDefeat: React.FC<BattleDefeatProps> = ({ battleName, turnsSurvived, enemiesDefeated, onContinue }) => {
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowContent(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="battle-defeat-overlay">
      <div className={`defeat-content ${showContent ? 'show' : ''}`}>
        <div className="defeat-header">
          <h1 className="defeat-title">DEFEAT</h1>
          <div className="defeat-banner"></div>
          {battleName && <p className="defeat-subtitle">{battleName}</p>}
        </div>

        <div className="defeat-body">
          <p className="defeat-message">Your party was overwhelmed. All units have fallen.</p>

          <div className="defeat-stats">
            <div className="defeat-stat">
              <span className="defeat-stat-value">{turnsSurvived}</span>
              <span className="defeat-stat-label">Turns Survived</span>
            </div>
            <div className="defeat-stat">
              <span className="defeat-stat-value">{enemiesDefeated}</span>
              <span className="defeat-stat-label">Enemies Defeated</span>
            </div>
          </div>
        </div>

        <div className="defeat-footer">
          <button className="return-btn" onClick={onContinue}>
            Return to World Map
          </button>
        </div>
      </div>
    </div>
  );
};

export default BattleDefeat;
